<template lang="">
  <div class="d-flex">
    <!-------------------------------- BLOC PIECES JOINTES-------------------------------->
    <v-col cols="12" sm="10" class="pb-0 mt-10">
      <v-toolbar color="#0B87BA" flat dense>
        <v-col
          cols="4"
          lg="4"
          xl="2"
          class="pa-0 font_color text-left"
        >
          PIECES JOINTES
        </v-col>
        <v-col cols="4" lg="4" xl="4" offset-xl="6" class="pa-0 text-right">
          <v-btn v-if="mode !== 'visualisation'"
            class="btnBold"
            color="#FF9900"
            dark
            rounded
            @click="onButtonClick"
          >
            <v-icon left>
              fa fa-plus
            </v-icon>
            Ajouter une piece jointe
          </v-btn>
          <input
            ref="uploader"
            class="d-none"
            type="file"
            accept="*"
            @change="onFileChanged"
          >
        </v-col>
      </v-toolbar>
      <div class="text-left pt-12">
        <v-sheet
          tabindex="0"
          width="100%"
          class="pa-2"
          ref="dropzone"
        >
        <p v-if="documents.length == 0"> Aucune pièce jointe n'a été ajoutée.</p>
          <v-list-item two-line v-if="documents.length>0">
            <v-list-item-content
              v-for="(document, index) in documents"
              v-bind:key="document.files.lastModified"
              v-bind:name="document.files.name"
              v-on:remove="document.splice(index, 1)"
            >
              <v-list-item-title class="d-flex justify-center">
                <a
                  :class="{ 'mr-1': index < documents.length - 1 }"
                  :href="document.chemin"
                  target="_blank"
                >
                  <img
                    v-if="document.files.name && document.files.name.split('.').pop() == 'pdf'"
                    src="@/assets/pdf.png"
                    alt=""
                  />
                  <img
                    v-else-if="document.files.name && (
                      document.files.name.split('.').pop().substring(0, 3) == 'doc' ||
                      document.files.name.split('.').pop().substring(0, 3) == 'txt'
                    )"
                    src="@/assets/doc.png"
                    alt=""
                  />
                  <img
                    v-else-if="document.files.name && (
                      document.files.name.split('.').pop().substring(0, 3) == 'xls' ||
                      document.files.name.split('.').pop().substring(0, 3) == 'csv'
                    )"
                    src="@/assets/excel.png"
                    alt=""
                  />
                  <img v-else src="@/assets/img.png" alt="" />
                </a>
              </v-list-item-title>
              <v-list-item-subtitle class="d-flex justify-center">
                {{document.files.name.substring(document.files.name.indexOf('-') + 1)}}
              </v-list-item-subtitle>
              <p class="d-flex justify-center">ajouté le : {{$moment(document.createdAt).format('DD/MM/YYYY')}}</p>
              <v-list-item-subtitle
                class="d-flex justify-center"
              >
                <v-btn
                  v-if="mode !== 'visualisation'"
                  @click="deleteDocument(document, index, true)"
                >
                  <strong>Supprimer</strong>
                </v-btn>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-sheet>
      </div>
    </v-col>
       <!-------------------------------- BLOC PIECES JOINTES-------------------------------->
         <Popup :dialog="dialog" text="Supprimer ce document ?" actions="" heightProp="" widthProp="" @emitDialog="dialog = $event" showClose="false"> 
              <v-card-actions class="mb-10">
              <v-btn class="actions mr-10" color="#0B87BA" width="100px"  large dark rounded @click="dialog = false">Non</v-btn>
              <v-btn class="actions" color="#0B87BA" width="100px" large dark rounded @click="deleteDocument(document, index, false)">Oui</v-btn>
            </v-card-actions>
        </Popup>

  </div>
</template>
<script>
import Popup from "@/components/shared/Popup";
export default {
  props: {
    documents: {
      type: Array,
      default: () => [],
    },
    mode: [String],
  },
  components: { Popup },
  data() {
    return {
      documentToDelete: null,
      indexToDelete: null,
      dialog: false,
      selectedFile: null,
      isSelecting: false,
    };
  },
  methods: {
    onButtonClick() {
      this.isSelecting = true;
      window.addEventListener("focus", () => { this.isSelecting = false; }, { once: true });
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      this.selectedFile = e.target.files[0];
      this.documents.push({ files: this.selectedFile });
    },
    deleteDocument(document, index, confirm) {
      if (confirm) {
        this.documentToDelete = document;
        this.indexToDelete = index;
        this.dialog = true;
      } else {
        this.documents.splice(this.indexToDelete, 1);
        this.documentToDelete = null;
        this.indexToDelete = null;
        this.dialog = false;
      }
    },
  },
  mounted() {
    const dropzone = this.$refs.dropzone.$el;
    if (dropzone) {
      dropzone.addEventListener("dragenter", e => { e.preventDefault(); this.dragover = true; });
      dropzone.addEventListener("dragleave", e => { e.preventDefault(); this.dragover = false; });
      dropzone.addEventListener("dragover",  e => { e.preventDefault(); this.dragover = true; });
      dropzone.addEventListener("drop", e => {
        e.preventDefault();
        if (e.dataTransfer) {
          for (let i = 0; i < e.dataTransfer.files.length; i++) {
            this.documents.push({ files: e.dataTransfer.files[i] });
          }
        }
      });
    }
  },
};
</script>
<style scoped>
.calendar-field {
  width: 20%;
}

img {
  width: 29px;
  height: 28px;
}

.font_color {
  font-weight: bold;
  color: #ffffff;
}

.width-50 {
  width: 30%;
}

.addPersonne {
  border-style: dashed;
  border-color: blue;
  color: blue;
}

.btnBold {
  font-weight: bold;
}

.errorMsg {
  text-align: left;
  color: red;
  /* margin-bottom: 0.7em;
  margin-top: 0.7em; */
}
</style>
